(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('materia', {
                    parent: 'app',
                    url: '/materia?page&code&description&macroMateriaId',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'materia.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/materia/materia.html',
                            controller: 'MateriaController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'descrizioneAnagrafica,desc',
                            squash: true
                        },
                        code: {
                            value: null,
                            squash: true
                        },
                        description: {
                            value: null,
                            squash: true
                        },
                        macroMateriaId: {
                            value: null,
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('materia');
                                return $translate.refresh();
                            }],
                        macroMateriaList: ['MacroMateria', function (MacroMateria) {
                            return MacroMateria.query().$promise
                        }],    
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                /* predicate: PaginationUtil.parsePredicate($stateParams.sort), */
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                code: $stateParams.code,
                                description: $stateParams.description,
                                macroMateriaId: $stateParams.macroMateriaId
                            }
                        }]
                    }
                }).state('materia.edit', {
                    parent: 'materia',
                    url: '/{id}/edit',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$mdDialog', 'Materia', '$state', 'MacroMateria', function ($stateParams, $mdDialog, Materia, $state, MacroMateria) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: false,
                                templateUrl: 'app/entities/materia/materia-dialog.html',
                                controller: 'MateriaDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: Materia.get({id: $stateParams.id}).$promise,
                                    macroMateriaList: MacroMateria.query().$promise
                                }
                            }).then(function (result) {
                                $state.go('materia', null, {reload: true});
                              },
                              function () {
                                $state.go('materia', null, {reload: false});
                              });
                        }]
                }).state('materia.new', {
                    parent: 'materia',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', '$state', 'MacroMateria', function ($mdDialog, $state, MacroMateria) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: false,
                                templateUrl: 'app/entities/materia/materia-dialog.html',
                                controller: 'MateriaDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: {},
                                    macroMateriaList: MacroMateria.query().$promise
                                }
                            }).then(function (result) {
                                $state.go('materia', null, {reload: true});
                              },
                              function () {
                                $state.go('materia', null, {reload: false});
                              });
                        }]
                }).state('materia.delete', {
                    parent: 'materia',
                    url: '/{id}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/entities/materia/materia-delete-dialog.html',
                                controller: 'MateriaDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['Materia', function (Materia) {
                                            return Materia.get({id: $stateParams.id}).$promise;
                                        }]
                                }
                            }).result.then(function () {
                                $state.go('materia', null, {reload: 'materia'});
                            },
                            function () {
                              $state.go('materia', null, {reload: false});
                            });
                        }]
                })
            }
})();